import { render, staticRenderFns } from "./PointProgramsStartWith.vue?vue&type=template&id=3695cc15&scoped=true&"
import script from "./PointProgramsStartWith.vue?vue&type=script&lang=js&"
export * from "./PointProgramsStartWith.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3695cc15",
  null
  
)

export default component.exports